import { useRef, useState } from 'react';

export default function Newsletter() {
  const formRef = useRef<HTMLFormElement>(null);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');
  const formUrl = 'https://readdy.ai/api/form/d9qatm4nlsngrm4llus0';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      form.reset();
      return;
    }

    const formData = new FormData(form);
    formData.delete('phone_alt');

    try {
      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore parse error */ }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        setErrorMessage(msg);
        setStatus('error');
      }
    } catch {
      setErrorMessage('网络错误，请检查网络连接后重试');
      setStatus('error');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-accent-50">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 md:mb-6 rounded-2xl bg-accent-100 flex items-center justify-center">
          <i className="ri-mail-send-line text-2xl text-accent-500"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
          订阅我们的内容
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-md mx-auto">
          每周获取精选文章和婚姻生活小贴士，让幸福常伴左右
        </p>

        {status === 'success' ? (
          <div className="bg-accent-100 text-accent-700 rounded-xl px-6 py-4 text-sm">
            <i className="ri-check-line mr-2"></i>
            订阅成功！感谢你的关注，我们会定期为你推送精选内容。
          </div>
        ) : (
          <form
            ref={formRef}
            onSubmit={handleSubmit}
            data-readdy-form
            id="newsletter-form"
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              required
              placeholder="输入你的邮箱地址"
              className="w-full sm:flex-1 px-5 py-3 text-sm rounded-full border border-background-300 bg-white focus:outline-none focus:ring-2 focus:ring-accent-300 focus:border-accent-300 transition-all"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-7 py-3 bg-accent-500 text-white rounded-full text-sm font-medium hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              订阅
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-sm text-red-500">{errorMessage}</p>
        )}
      </div>
    </section>
  );
}